__turbopack_context__.v({
  "checklist": "EventReadinessCard-module-scss-module__mvs5qq__checklist",
});
